import axios from 'axios';
import config from '@/vue-caas/config/config.js';
import { isEmptyProcessWindowList, changeProcessShareFlag, compareTableData } from '@/vue-caas/utils/process';

const setupURI = config.setupApiUrl;
const userCompModule = {
  state: {
    userComponentList: [],
    userComponentSelectBoxList: [],
    dataSetUserComponent: [],
    filter: {},
    userComponentHistoryList: [],
    userComponentChange: {},
  },
  mutations: {
    'SET_STORE_USER_COMPONENT_LIST'(state, userComponentList) {
      if (JSON.stringify(state.dataSetUserComponent) !== JSON.stringify(userComponentList) && !isEmptyProcessWindowList()) {
        changeProcessShareFlag('USR');
      }
      state.userComponentList = userComponentList;
      state.dataSetUserComponent = userComponentList;
    },
    'SET_STORE_USER_COMPONENT_SELECT_BOX_LIST' (state, userComponentSelectBoxList) {
      state.userComponentChange = compareTableData(state.userComponentSelectBoxList, userComponentSelectBoxList, "uc_id");
      state.userComponentSelectBoxList = userComponentSelectBoxList;
    },
    'SET_STORE_USER_COMPONENT_ID' (state, id) {
      if (!isEmptyProcessWindowList()) {
        changeProcessShareFlag('USR');
      }
    },
    'SET_STORE_USER_COMPONENT_HISTORY_LIST'(state, userComponentList) {
      state.userComponentHistoryList = userComponentList;
    },
    'SET_STORE_USER_COMPONENT_FILTER'(state, filter) {
      let datarows = state.dataSetUserComponent;
      state.filter = filter;
      let filterBy = state.filter;
      let listResult = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter(item => {
          if (filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }

          return false;
        });
      }
      state.userComponentList = listResult;
    },
  },
  actions: {
    getUserComponentList: async ({ commit }, params) => {
      await axios.post(`${setupURI}/userComponent/list`, params).then((response) => {
        commit('SET_STORE_USER_COMPONENT_LIST', response.data);
      }).catch((ex) => {
        throw ex;
      });
    },
    getUserComponentSelectBoxList: async ({ commit }, params) => {
      await axios.post(`${setupURI}/userComponent/list`, params).then((response) => {
        commit('SET_STORE_USER_COMPONENT_SELECT_BOX_LIST', response.data);
      }).catch((ex) => {
        throw ex;
      });
    },
    insertUserComponent: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/userComponent/insert`, params);
        commit('SET_STORE_USER_COMPONENT_ID', response.data);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    updateUserComponent: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/userComponent/update`, params);
        commit('SET_STORE_USER_COMPONENT_ID', response.data);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    deleteUserComponent: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/userComponent/delete`, params);
        commit('SET_STORE_USER_COMPONENT_ID', response.data);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    toggleLocked: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/userComponent/toggleLocked`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    setFilterUserComponent: async ({ commit }, filter) => {
      commit('SET_STORE_USER_COMPONENT_FILTER', filter);
    },
    userComponentHistory: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/userComponent/history/list`, params);
        commit('SET_STORE_USER_COMPONENT_HISTORY_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_USER_COMPONENT_HISTORY_LIST', []);
        throw err;
      }
    },
    changeUserComponentVersionHistory: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/userComponent/save`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    deleteUserComponentHistory: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/userComponent/deleteHistory`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    userComponentCheckIn: async ({ commit }, params) => {
        try {
          const response = await axios.post(`${setupURI}/userComponent/deploy`, params);
          return response.data;
        } catch (err) {
          throw err;
        }
      },
  },
  getters: {
    userComponentList: state => state.userComponentList,
    userComponentHistoryList: state => state.userComponentHistoryList,
    userComponentSelectBoxList: state => state.userComponentSelectBoxList,
    userComponentChange: state => state.userComponentChange,
  }
};
export default userCompModule;